const getters = {
    token: state => state.user.token,
    user: state => state.user.user,
    logged: state => state.user.logged,
    errorLogs: state => state.errorLog.logs,
    num_results: state => state.user.num_results
}
export default getters